<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>Arms</h2>
      </div>
    </div>

    <!-- Filters -->
    <div class="wrapper wrapper-content">
      <!-- <div class="ibox-content mb-1 px-3 py-2"> -->
        <!-- <div class="form-group mb-1">
          <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
            <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
              <label class="mb-0">Country</label>
              <input type="text" class="form-control my-md-2 my-lg-0" v-model="searchField.country" />
            </div>
            <div class="form-group mb-lg-0 w-100 px-1">
              <label class="mb-0">Status</label>
               <select class="form-select" name="reason to resolve" id="resolveReason" v-model="searchField.status">
                <option value="" >All</option>
                <option v-for="status in CountryStatus" :key="status.status" :value="status.status">{{ status.status }}</option>
              </select>
            </div>
            <span class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end" @click="search()">
              Search
            </span>
          </div>
        </div> -->
      <!-- </div> -->

      <!-- Table -->
      <div class="ibox-body">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">ARM List</h5>
          <div class="d-flex">

            <div class="position-relative align-self-center"  :class="{ 'mr-3': armList.length != 0 }"
              aria-label="Create ARM" tabindex="0">
              <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="17" alt="Create ARM"
                @click="CreateARM()" />
              <div class="tool-tip">{{ $t("navigations.create arm") }}</div>
            </div>
         
          </div>
        </div>
        <div class="ibox-content">
         
          <div class="text-center" v-if="showTableLoading === true">
            <img src="../../assets/img/loading.gif" width="15" class="" alt="Waiting for login" />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th class="sort_block"  @click="SortSelected('armName', 1)"><div class="d-flex flex-row justify-content-between">
                     ARM Name
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div></th>
                  <th class="sort_block"  @click="SortSelected('armCode', 1)"><div class="d-flex flex-row justify-content-between">
                    ARM Code
                     <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                 
                  <th class="text-center">Active</th>
                  <th>Arm Type</th>
                  <th class="text-center">Edit</th>
                  <th class="text-center">Delete</th>
                </tr>
              </thead>
          <tbody>
  <tr v-for="item in armList" :key="item.id">
    <td>{{ item.ArmName }}</td>  
    <td>{{ item.ArmCode }}</td>  
    <td class="text-center">
      <input type="checkbox" :checked="item.IsActive" onclick="return false" readonly /> 
    </td>
    <td>{{ item.ArmType }}</td> 
    <td class="text-center">
      <i class="fa fa-edit edit-delete" @click="EditArm(item.Id)" style="color: #a13b7c"></i>
    </td>
    <td class="text-center">
      <i class="fa fa-trash edit-delete" style="color: #a13b7c" @click="DeleteArm(item.Id)"></i>
    </td>
  </tr>
</tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div v-if="armList.length != 0" class="row mt-1 mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="
                  dataTables_paginate
                  paging_simple_numbers
                  pagination
                  float-right
                ">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1" active-color="#618bd7"
                    @update:modelValue="loadPage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<ArmModal
  v-if="showCreatearmModal"
  :editingId="editingArmId"
  @closeModal="closeArmModal"
  @saved="refreshArmList"
/>
</template>
<script src="./ArmManagement.js"></script>